import {createSimpleAction, createTypeAction} from "../utils/actionUtils";

export const LOAD_COMMON = 'LOAD_COMMON'
export const LOAD_COMMON_SUCCESS = 'LOAD_COMMON_SUCCESS'
export const LOAD_COMMON_FAILURE = 'LOAD_COMMON_FAILURE'
export const LOAD_LOGGED_ARTIST_SETTINGS_SUCCESS = 'LOAD_LOGGED_ARTIST_SETTINGS_SUCCESS'

export const loadCommonFailureAction = createTypeAction(LOAD_COMMON_FAILURE)
export const loadCommonSuccessAction = createSimpleAction(LOAD_COMMON_SUCCESS, 'common')
export const loadCommonAction = createTypeAction(LOAD_COMMON)
export const loadLoggedArtistSettingsSuccessAction = createSimpleAction(LOAD_LOGGED_ARTIST_SETTINGS_SUCCESS, 'artistSettings')

export const DISABLE_ARTIST_INFO = 'DISABLE_ARTIST_INFO'
export const disableArtistInfoAction = createSimpleAction(DISABLE_ARTIST_INFO, 'infoType')

export const RELOAD_COMMON_ARTISTS = 'RELOAD_COMMON_ARTISTS'
export const reloadCommonArtistsAction = createTypeAction(RELOAD_COMMON_ARTISTS)

export const RELOAD_COMMON_ARTISTS_SUCCESS = 'RELOAD_COMMON_ARTISTS_SUCCESS'
export const reloadCommonArtistsSuccessAction = createSimpleAction(RELOAD_COMMON_ARTISTS_SUCCESS, 'artistMap')

export const RELOAD_COMMON_ARTISTS_FAILED = 'RELOAD_COMMON_ARTISTS_FAILED'
export const reloadCommonArtistsFailedAction = createTypeAction(RELOAD_COMMON_ARTISTS_FAILED)

export const RELOAD_COMMON_STUDIO = 'RELOAD_COMMON_STUDIO'
export const reloadCommonStudioAction = createTypeAction(RELOAD_COMMON_STUDIO)
export const RELOAD_COMMON_STUDIO_SUCCESS = 'RELOAD_COMMON_STUDIO_SUCCESS'
export const reloadCommonStudioSuccessAction = createSimpleAction(RELOAD_COMMON_STUDIO_SUCCESS, 'studio')
export const RELOAD_COMMON_STUDIO_FAILURE = 'RELOAD_COMMON_STUDIO_FAILURE'
export const reloadCommonStudioFailureAction = createTypeAction(RELOAD_COMMON_STUDIO_FAILURE)

export const RELOAD_COMMON_TERMINTYPEN = 'RELOAD_COMMON_TERMINTYPEN'
export const reloadCommonTermintypenAction = createTypeAction(RELOAD_COMMON_TERMINTYPEN)
export const RELOAD_COMMON_TERMINTYPEN_SUCCESS = 'RELOAD_COMMON_TERMINTYPEN_SUCCESS'
export const reloadCommonTermintypenSuccessAction = createSimpleAction(RELOAD_COMMON_TERMINTYPEN_SUCCESS, 'termintypMap')
export const RELOAD_COMMON_TERMINTYPEN_FAILURE = 'RELOAD_COMMON_TERMINTYPEN_FAILURE'
export const reloadCommonTermintypenFailureAction = createTypeAction(RELOAD_COMMON_TERMINTYPEN_FAILURE)

export const UPDATE_STUDIO = 'UPDATE_STUDIO'
export const updateStudioAction = createSimpleAction(UPDATE_STUDIO, 'studio')

export const STUDIO_CHANGED = "STUDIO_CHANGED"
export const studioChangedAction = createTypeAction(STUDIO_CHANGED)
export const CLEAR_STUDIO_CHANGED = 'STUDIO_CLEAR_CHANGED'
export const clearStudioChangedAction = createTypeAction(CLEAR_STUDIO_CHANGED)

export const DELETE_STUDIO_LOCATION = 'DELETE_STUDIO_LOCATION'
export const deleteStudioLocation = createSimpleAction(DELETE_STUDIO_LOCATION, 'tatortId')

export const SAVE_STUDIO_LOCATION = 'SAVE_STUDIO_LOCATION'
export const saveStudioLocationAction = createSimpleAction(SAVE_STUDIO_LOCATION, 'location')

export const CREATE_SUPPORT_TICKET = 'CREATE_SUPPORT_TICKET'
export const createSupportTicketAction = createSimpleAction(CREATE_SUPPORT_TICKET, 'ticket')

export const CREATE_SUPPORT_TICKET_SUCCESS = 'CREATE_SUPPORT_TICKET_SUCCESS'
export const createSupportTicketSuccessAction = createTypeAction(CREATE_SUPPORT_TICKET_SUCCESS)

export const CREATE_SUPPORT_TICKET_FAILURE = 'CREATE_SUPPORT_TICKET_FAILURE'
export const createSupportTicketFailureAction = createTypeAction(CREATE_SUPPORT_TICKET_FAILURE)

export const CLEAR_SUPPORT_TICKET = 'CLEAR_SUPPORT_TICKET'
export const clearSupportTicketAction = createTypeAction(CLEAR_SUPPORT_TICKET)

